import { render, staticRenderFns } from "./GiftList.vue?vue&type=template&id=c75fe4d6&scoped=true&lang=pug&"
import script from "./GiftList.vue?vue&type=script&lang=ts&"
export * from "./GiftList.vue?vue&type=script&lang=ts&"
import style0 from "./GiftList.vue?vue&type=style&index=0&id=c75fe4d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c75fe4d6",
  null
  
)

export default component.exports